/* The outer section keeps sidebar state through AJAX sorting/filter updates. */
(() => {
  if (customElements.get('jss-collection-filter-toggle')) return;
  customElements.define('jss-collection-filter-toggle', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-jss-collection]');
      this.button = this.querySelector('button');
      if (!this.root || !this.button || this.onClick) return;
      this.onClick = () => {
        this.root.toggleAttribute('data-filters-collapsed');
        this.refresh();
      };
      this.button.addEventListener('click', this.onClick);
      this.refresh();
    }
    refresh() {
      const expanded = !this.root.hasAttribute('data-filters-collapsed');
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.setAttribute('aria-label', expanded ? 'Hide filters' : 'Show filters');
      this.querySelector('[data-filter-symbol]').textContent = expanded ? '−' : '+';
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.onClick = null;
    }
  });
})();
